import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GET_DISBURSEMENT_FORM_LIST } from "../../../Types";
import storage from "../../../apis/Storage";

export const getDisbursementFormList = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/LenderFinancing/GetDisbursementFormList`, postedData)
    .then(({ data }) => {
      dispatch({
        type: GET_DISBURSEMENT_FORM_LIST,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const updateDisbursementForm = (formValues) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post("api/LenderFinancing/updateDisbursementForm", formValues)
    .then(({ data }) => {
      dispatch(hideLoading());
      if (data) {
        if (data.isSuccess) {
          toast.success(
            "Images For Disbursement Form Detail Updated successfully"
          );
        } else {
          toast.error(data.message);
        }
      }
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const cancelLoan = (id) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/Lender/CreditBook/CanceleRejectedLoan?loanDisplayId=${id}`)
    .then(({ data }) => {
      dispatch(hideLoading());
      if (data) {
        if (data.isSuccess) {
          toast.success("Loan canceled successfully");
        } else {
          toast.error(data.message);
        }
      }
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const rejectedLoanIntrnalApply = (id) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/Lender/CreditBook/RejectedLoanIntrnalApply?loanDisplayId=${id}`)
    .then(({ data }) => {
      dispatch(hideLoading());
      if (data) {
        if (data.isSuccess) {
          toast.success(data.response);
        } else {
          toast.error(data.message);
        }
      }
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const applyNewLoan = (formValues, onCLose) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post("api/Lender/CreditBook/InitiateLoanForWeb", formValues)
    .then(({ data }) => {
      dispatch(hideLoading());
      if (data) {
        if (data.isSuccess) {
          toast.success(data.message);
          onCLose();
        }
        else {
          toast.error(data.message);
        }
      }
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};